if (!Enum) {
    var Enum = {};
}

Enum.STREAM_TYPE = {
    CREATED: "streamCreated"
};

Object.freeze(Enum.STREAM_TYPE);